import { createFileRoute } from "@tanstack/react-router";
import { kitsWebConversationsRoute } from "@/features/kits-conversations";

export const Route = createFileRoute("/api/kits/web/conversations")({
    ...kitsWebConversationsRoute,
});
